<template>
  <div class="step">
    <div class="exercise">
      <h1>Step 1</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step-one'
}
</script>
